module.exports = __webpack_public_path__ + "static/media/wardrobe.0e005ad5.svg";